import { render } from "./WalletExchangePositionsList.vue?vue&type=template&id=63660e86&scoped=true"
import script from "./WalletExchangePositionsList.vue?vue&type=script&lang=js"
export * from "./WalletExchangePositionsList.vue?vue&type=script&lang=js"

import "./WalletExchangePositionsList.vue?vue&type=style&index=0&id=63660e86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63660e86"]])

export default __exports__